module.exports = "/_next/static/images/d62b7f823ca8cc4ba58c5d03396f9633-slide1desktop.jpg.webp";